import $ from 'jquery';

// Initialize statuses page work type selector
export function initStatusesPage() {
  $('#work_type').off('change.statuses');
  $('#work_type').on('change.statuses', function() {
    const workType = $(this).val();
    window.location.href = '?work_type=' + workType;
  });
}

// Expose to global scope
window.initStatusesPage = initStatusesPage;

// Auto-initialize on turbo:load
$(document).on('turbo:load', function() {
  if ($('#work_type').length > 0 && $('[data-section="statuses"]').length > 0) {
    initStatusesPage();
  }
});
